import ChatApiRequest from "~/chat/ts/service/request/ChatApiRequest";
import MessageWrapper from "~/chat/ts/data/chat/MessageWrapper";
import ObjectHelper from "~/ts/library/ObjectHelper";
import MessageStorage from "~/chat/ts/service/messages/MessageStorage";

export async function setMessageReaction(message: MessageWrapper, emoji?: string) {
    if (!message.rawMessage.other) {
        message.rawMessage.other = {};
    }
    let other = message.rawMessage.other;
    let reactionsCopy = ObjectHelper.jsonClone(message.reactions);
    let reactions = other.reactions ?? [];
    if (!emoji) {
        reactions = reactions.filter(item => !item.isFromClient);
    } else {
        let reaction = reactions.find(item => item.isFromClient);
        if (!reaction) {
            reaction = {
                isFromClient: true,
                emoji,
                operatorId: undefined,
                isFromOperator: false
            };
            reactions.push(reaction);
        }
        reaction.emoji = emoji;
    }
    other.reactions = reactions;
    MessageStorage.saveMessage(message.rawMessage);

    let result = await ChatApiRequest.make({
        method: "setMessageReaction",
        p: {
            messageId: message.id,
            emoji
        }
    });
    if (!result.isSuccess()) {
        other.reactions = reactionsCopy;
        MessageStorage.saveMessage(message.rawMessage);
    }
}